import { useEffect, type ReactElement } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router';

import Tracker from './tracker';

type TrackerRouteProps = {
  element: ReactElement;
};

const TrackerRoute = ({ element }: TrackerRouteProps) => {
  const location = useLocation();

  useEffect(() => {
    const page = location.pathname + location.search;
    Tracker.set({ page });
    Tracker.pageview(page);
  }, [location]);

  return element;
};

TrackerRoute.propTypes = {
  element: PropTypes.element.isRequired,
};

export default TrackerRoute;
